import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import isNotNull from "sprout-lib/dist/isNotNull";
import { LockOutlined, PeopleOutlined, Public } from "sprout-ui-icons";
import { Select } from "../Form";
export var SelectVisibilityValue;
(function(SelectVisibilityValue) {
    SelectVisibilityValue["PUBLIC"] = "public";
    SelectVisibilityValue["PRIVATE"] = "private";
    SelectVisibilityValue["TEAM"] = "team";
})(SelectVisibilityValue || (SelectVisibilityValue = {}));
export var SelectVisibilityVariant;
(function(SelectVisibilityVariant) {
    SelectVisibilityVariant[SelectVisibilityVariant["DEFAULT"] = 0] = "DEFAULT";
    SelectVisibilityVariant[SelectVisibilityVariant["TEAM"] = 1] = "TEAM";
})(SelectVisibilityVariant || (SelectVisibilityVariant = {}));
const SelectVisibility = (props)=>{
    const { value , onChange , variant =SelectVisibilityVariant.DEFAULT  } = props;
    const options = useMemo(()=>[
            {
                label: "Public",
                icon: Public,
                value: SelectVisibilityValue.PUBLIC,
                description: `Anyone can see this tree. Only tree members can edit.`
            },
            variant === SelectVisibilityVariant.TEAM ? {
                label: "Workspace",
                icon: PeopleOutlined,
                value: SelectVisibilityValue.TEAM,
                description: `All workspace members can view this tree. Only members that join the tree can edit.`
            } : null,
            {
                label: "Private",
                icon: LockOutlined,
                value: SelectVisibilityValue.PRIVATE,
                description: `Only tree members can see and edit this tree.`
            }, 
        ].filter(isNotNull), [
        variant
    ]);
    const handleChange = useCallback((nextValue)=>{
        onChange(nextValue);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ _jsx(Select, {
        value: value,
        onChange: handleChange,
        label: "Choose privacy",
        options: options
    });
};
export default SelectVisibility;
